export default {"src":"/_next/static/media/nvme-ssd.e7297da6.svg","height":550,"width":600,"blurWidth":0,"blurHeight":0};